import global from "@/plugin/global"
import {buildBookUrl} from "@/util/book/bookUrl"

const externalBookUrl = process.env.VUE_APP_DOT_BOOK_APP
const embedBook = externalBookUrl && process.env.VUE_APP_DOT_BOOK_EMBED === 'true'

export default [
    {
        name: "root",
        path: "/",
        component: () => import(/* webpackChunkName: "main" */ "@/view/apps/Main.vue"),
        meta: {
            layout: "DefaultLayout",
            title: "Dot Apps : Home",
            // 창 제목은 router/index.js 의 getRouteTitle 이 브랜드 + 번역한 화면 이름으로 만든다.
            titleBrand: "Dot Apps",
            titleKey: "홈",
            auth: false,
        },
        beforeEnter: (to, from, next) => {
            if (global.isKCHFUser()) {
                return next({name: "kchfMain"})
            }
            next()
        },
    },
    {
        name: "canvas",
        path: "/canvas",
        component: () => import(/* webpackChunkName: "dot-canvas" */ /* webpackPrefetch: true */ "@/view/apps/DotCanvas.vue"),
        meta: {
            layout: "WideLayout",
            title: "Dot Apps : Dot Canvas",
            // 편집기가 지금 연 파일을 주소의 query 에 적는다(NEW-G6-2). 화면이 바뀐 것이 아니므로 화면 이름을 다시 읽지 않는다(App.vue).
            announceQueryChange: false,
        },
    },
    {
        name: "book",
        path: "/book",
        component: embedBook
            ? () => import(/* webpackChunkName: "dot-book-embedded" */ "@/view/apps/EmbeddedDotBook.vue")
            : () => import(/* webpackChunkName: "dot-book" */ "@/view/apps/DotBook.vue"),
        meta: {
            layout: embedBook ? "EmbeddedBookLayout" : "WideLayout",
            title: "Dot Apps : Dot Book",
        },
        beforeEnter: (to, from, next) => {
            if (externalBookUrl && !embedBook) {
                try {
                    window.location.replace(buildBookUrl(externalBookUrl, to.query.fileId))
                } catch {
                    next(false)
                }
                return
            }
            next()
        },
    },
    // 닷북 매뉴얼 — 닷북 편집 화면에서 새 탭으로 연다(DCE-329). 닷북 /manual 을 같은 iframe 화면으로 띄워 홈페이지 주소·언어를
    // 그대로 쓴다. 매뉴얼은 로그인 없이 보는 문서라 auth 를 끈다.
    ...(embedBook ? [{
        name: "bookManual",
        path: "/book/manual",
        component: () => import(/* webpackChunkName: "dot-book-embedded" */ "@/view/apps/EmbeddedDotBook.vue"),
        meta: {
            layout: "EmbeddedBookLayout",
            title: "Dot Apps : Dot Book Manual",
            auth: false,
        },
    }] : []),
    {
        name: "cloud",
        path: "/cloud",
        component: () => import(/* webpackChunkName: "dot-cloud" */ "@/view/apps/DotCloud.vue"),
        meta: {
            layout: "CloudLayout",
            title: "Dot Apps : Dot Cloud",
        },
    },
]
